import type { IFormulaParams } from "./tournament.types";
import type { CampaignLevel, CampaignTypes, ICampaignResources } from "../campaignShared.types";
import type { ICampaignInfo } from "../campaign.types";

export type PrizePopFormula = 'RANDOM';
export type PrizeType = 'MONEY';

export enum PrizePopStatuses {
  PROMO = 'PROMO',
  ACTIVE = 'ACTIVE',
  COMPLETED_VISIBLE = 'COMPLETED_VISIBLE',
};

/** Priority order shared across prize pop campaigns */
export const PRIZE_POP_STATUS_ORDER: Record<PrizePopStatuses, number> = {
  [PrizePopStatuses.ACTIVE]: 1,
  [PrizePopStatuses.PROMO]: 2,
  [PrizePopStatuses.COMPLETED_VISIBLE]: 3
};

export const PRIZE_POP_CAMPAIGN_TYPE: Extract<CampaignTypes, 'prize_pop'> = 'prize_pop';

export interface IPrizePopResources extends ICampaignResources {
  PrizePopIcon?: string;
}

/** Prize Pop card props */
export interface IPrizePopCampaignInfo extends Omit<ICampaignInfo, 'component'> {
  prizeFund: number;
  resources: IPrizePopResources;
}

export interface PrizePopIntervalTimeRange {
  startTime: string;
  endTime: string;
}

export interface PrizePopIntervalDateRange {
  startRangeDate: string;
  endRangeDate: string;
}

export interface PrizePopInterval {
  range: PrizePopIntervalDateRange;
  hoursRange: PrizePopIntervalTimeRange[];
}

export interface IPrizePopCampaign {
  id: string;
  name: string;
  terms: string;
  status: PrizePopStatuses;
  startDate: string;
  endDate: string;
  visibleEndDate: string;
  prizeFund: number;
  level: CampaignLevel;
  games: string[];
  formula: PrizePopFormula;
  formulaParams: IFormulaParams | null;
  minSpinNumber: number;
  minStake: number;
  baseCurrency: string;
  joined: boolean;
  resources: IPrizePopResources;
  intervals: PrizePopInterval[];
  joinedPlayersCount: number;
  totalPrizesCount: number;
  prizesWonCount: number;
  type: typeof PRIZE_POP_CAMPAIGN_TYPE;
}

export interface IPrizePopPrize {
  value: string;
  type: PrizeType;
  currencyCode: string;
  count: number;
  remaining: number;
}

export interface IPrizePopPrizesResponse {
  totalRemaining: number;
  prizes: IPrizePopPrize[];
}

export interface IPrizePopWin {
  name: string;
  casinoPlayerId: string;
  casinoId: number;
  prize: string;
  type: PrizeType;
  currencyCode: string;
  date?: string;
  wonDate?: string;
  gameKey?: string;
}

export interface PrizePopWinsResponse {
  wins: IPrizePopWin[];
  totalWins: number;
}
